import styled, { css } from 'styled-components/macro'
import { Overlay, styleReset } from 'styles/misc'
import { theme } from 'styles/theme'

export const Container = styled.div`
  position: relative;
  width: 100%;
  max-width: 106rem;
  margin: 6rem auto 10rem;
  background: #333;
  aspect-ratio: 16 / 9;
  overflow: hidden;

  &,
  video,
  img {
    clip-path: polygon(
      2.5% 0,
      97.5% 0,
      100% 4.5%,
      100% 95.5%,
      97.5% 100%,
      2.5% 100%,
      0 95.5%,
      0 4.5%
    );
  }

  video,
  img {
    ${Overlay}
  }
`

export const VideoTrigger = styled.button`
  ${styleReset}
  ${Overlay}

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg {
    display: block;
    width: 9.2rem;
    height: 9.2rem;
  }

  &:hover,
  &:focus-visible {
    color: #ccc;
  }
`

const trackStyles = css`
  width: 100%;
  height: 3px;
  cursor: pointer;
  box-shadow: none;
  border-radius: 4px;
  appearance: none;
  background: #ffffff55;
  border: none;
`

const thumbStyles = css`
  box-shadow: none;
  border: none;
  height: 14px;
  width: 14px;
  border-radius: 8px;
  appearance: none;
  background: white;
  cursor: pointer;
  margin-top: -4px;
`

export const Range = styled.input.attrs({ type: 'range' })`
  appearance: none;
  background-color: transparent;

  &:focus {
    outline: none;
  }

  &::-webkit-slider-runnable-track {
    ${trackStyles}
    height: 4px;
  }

  &::-webkit-slider-thumb {
    ${thumbStyles}
  }

  &::-moz-range-track {
    ${trackStyles}
  }

  &::-moz-range-progress {
    ${trackStyles}
    background-color: white;
  }

  &::-moz-range-thumb {
    ${thumbStyles}
  }

  &:disabled::-moz-range-thumb {
    cursor: not-allowed;
    background: #aaa;
  }

  &:disabled::-moz-range-track {
    cursor: not-allowed;
    background: #ddd;
  }

  &::-ms-track {
    ${trackStyles}
  }

  &::-ms-fill-lower {
    ${trackStyles}
  }

  &::-ms-fill-upper {
    ${trackStyles}
  }

  &::-ms-thumb {
    ${thumbStyles}
  }

  &[data-progress] {
    flex: 4;
    margin: 0 1rem;
  }

  &[data-volume] {
    width: 0;
    flex-grow: 1;
  }
`

export const Controls = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0 2rem;
  transform: translateY(100%);
  transition: 0.3s transform 0.5s ${theme.ease.in};
  backdrop-filter: blur(8px);
  background: #14130f99;

  ${Container}:hover & {
    transform: none;
    transition-delay: 0;
    transition: 0.3s transform 0s ${theme.ease.out};
  }

  button {
    ${styleReset}
    padding: 0.8rem;
    font-size: 2.4rem;
    color: white;
    cursor: pointer;

    &:hover,
    &:focus-visible {
      color: #eee;
      background-color: rgba(255, 255, 255, 0.2);
    }

    &[data-volume-button] {
      font-size: 3rem;
    }
  }

  svg {
    display: block;
    width: 1em;
    height: 1em;
  }
`

export const Time = styled.span`
  display: block;
  font-size: 1.3rem;
  font-weight: 500;
  width: 4.5em;
  text-align: right;

  input + & {
    text-align: left;
  }
`

export const VolumeWrapper = styled.div`
  position: relative;

  &:not(:hover) > div {
    opacity: 0;
    transform: translateX(4rem) translateY(1rem) rotateZ(-90deg);
    pointer-events: none;
  }

  > div {
    position: absolute;
    display: flex;
    align-items: center;
    bottom: 100%;
    left: 0;
    width: 12rem;
    height: 4rem;
    padding: 0 1rem;
    transform: translateX(4rem) rotateZ(-90deg);
    transform-origin: 0 100%;
    transition: all 0.2s ${theme.ease.inOut};
    backdrop-filter: blur(8px);
    background: #14130f99;
  }
`
